/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.userScanReceipt.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class CustomerDetailsModel(
    /** A unique ID identifying this customer */
    @SerialName("id")
    val id: String,

    @SerialName("display_name")
    val displayName: String?,

    @SerialName("email")
    val email: String?,

    @SerialName("phone")
    val phone: String?,

    @SerialName("first_name")
    val firstName: String?,

    @SerialName("last_name")
    val lastName: String?,

    @SerialName("qrcode")
    val qrcode: String?,

    @SerialName("gender")
    val gender: String?,

    @SerialName("birth_date")
    val birthDate: String?,

    @SerialName("language")
    val language: String?,

    @SerialName("country_code")
    val countryCode: String?,

    @SerialName("profile_photo")
    val profilePhoto: String?,

    @SerialName("created_at")
    val createdAt: String?,

    @SerialName("updated_at")
    val updatedAt: String?,

    @SerialName("enabled")
    val enabled: Boolean?,

    @SerialName("email_verified")
    val emailVerified: Boolean?,

    @SerialName("phone_verified")
    val phoneVerified: Boolean?,

    @SerialName("balance")
    val balance: BalanceDetailsModel?
) : Model()
